import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Col, FormFeedback, Input, Modal, ModalBody, Row,
} from 'reactstrap';

import AppLoading from 'components/App/Loading';

import { checkHadError } from 'utils';

import images from 'assets/images';

import './ModalAdminConfirm.scss';

function ModalAdminConfirm(props) {
  const {
    isLoadingBtn,
    isOpen,
    isRevertBtn,
    loading,
    isReject,
    isHiddenButton,

    children,
    btnConfirmName,
    btnCloseName,
    src,

    notification,
    validation,

    onCloseClick,
    onAcceptConfirm,
  } = props;

  return (
    <Modal className="modal-confirm" isOpen={isOpen} toggle={onCloseClick} centered>
      <AppLoading loading={loading} loaderOnPage />

      <ModalBody className="modal-confirm__body position-relative">
        <button
          type="button"
          className="btn btn__close"
          onClick={onCloseClick}
          aria-label="Close"
        >
          <div className="image-wrapper">
            <img src={images.modalClose.default} alt="" className="img-fluid img-close" />
          </div>
        </button>

        <Row>
          <Col lg={12}>
            <div className="text-center">
              <div className="image-wrapper">
                <img
                  src={src}
                  alt=""
                  className="img-delete"
                />
              </div>
              <h2 className="title">{notification.message}</h2>
              {notification.description && <h4 className="subtitle">{notification.description}</h4>}
              {isReject
                ? (
                  <>
                    <Input
                      name="reason"
                      className="form-control mt-3"
                      placeholder="Nhập lý do từ chối"
                      type="textarea"
                      rows="5"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.reason || ''}
                      invalid={checkHadError(validation, 'reason')}
                      maxLength="1000"
                    />

                    <div className="d-flex">
                      <FormFeedback type="invalid" className="error-text">
                        {validation.errors.reason}
                      </FormFeedback>

                      <div className="form-content-length">
                        {validation.values.reason?.length || 0}
                        /1000
                      </div>
                    </div>
                  </>
                )
                : null}
            </div>
          </Col>
        </Row>

        {children && (
          <div className="children-content">
            {children}
          </div>
        )}

        {!isHiddenButton && (
          <Row>
            <Col>
              {isRevertBtn
                ? (
                  <div className="text-center btn__group">
                    <button
                      type="button"
                      className="btn btn-outline-light-secondary font-size-14 btn-width me-2"
                      onClick={onAcceptConfirm}
                    >
                      {btnConfirmName}
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary btn-width font-size-14 me-2"
                      onClick={onCloseClick}
                    >
                      {btnCloseName}
                    </button>
                  </div>
                ) : (
                  <div className="text-center btn__group">
                    <button
                      type="button"
                      className="btn btn-outline-light-secondary font-size-14 btn-width btn-close-modal"
                      onClick={onCloseClick}
                    >
                      {btnCloseName}
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary btn-width font-size-14 btn-confirm"
                      onClick={onAcceptConfirm}
                      disabled={isLoadingBtn}
                    >
                      {
                      isLoadingBtn ? (
                        <>
                          <i className="bx bx-loader bx-spin align-middle me-1" />
                          {btnConfirmName}
                        </>
                      ) : (
                        btnConfirmName
                      )
                    }
                    </button>
                  </div>
                )}
            </Col>
          </Row>
        )}
      </ModalBody>
    </Modal>
  );
}

ModalAdminConfirm.propTypes = {
  isLoadingBtn: PropTypes.bool,
  isOpen: PropTypes.bool,
  isRevertBtn: PropTypes.bool,
  loading: PropTypes.bool,
  isReject: PropTypes.bool,
  isHiddenButton: PropTypes.bool,

  children: PropTypes.string,
  btnConfirmName: PropTypes.string,
  btnCloseName: PropTypes.string,
  src: PropTypes.string,

  notification: PropTypes.instanceOf(Object).isRequired,
  validation: PropTypes.instanceOf(Object),

  onCloseClick: PropTypes.func,
  onAcceptConfirm: PropTypes.func,
};

ModalAdminConfirm.defaultProps = {
  isLoadingBtn: false,
  isOpen: false,
  isRevertBtn: false,
  loading: false,
  isReject: false,
  isHiddenButton: false,

  children: '',
  src: images.modalGarbageCan.default,
  btnConfirmName: 'Xác nhận',
  btnCloseName: 'Hủy',

  validation: {},

  onCloseClick: () => { },
  onAcceptConfirm: () => { },
};

export default memo(ModalAdminConfirm);
